import { render, staticRenderFns } from "./AsistencialView.vue?vue&type=template&id=6284a1a3"
import script from "./AsistencialView.vue?vue&type=script&lang=js"
export * from "./AsistencialView.vue?vue&type=script&lang=js"
import style0 from "./AsistencialView.vue?vue&type=style&index=0&id=6284a1a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports